const visitTypeCategories = {
  Asistencia: 1,
  Ausencia: 2,
  HorasCompensatorias: 3,
  ReposicionDeAnoAnterior: 4,
};

export default visitTypeCategories;
